export default __webpack_public_path__ + "static/media/Eduardo Filho_.bd336f0f.png";